var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Divider, Typography } from '@mui/material';
import SelectFormik from '../../Formik/Select/SelectFormik';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useTeams } from '@src/app/pages/TeamPage/TeamHooks/Team.hooks';
import { useDivisions } from '@src/app/pages/DivisionPage/DivisionHooks/Division.hooks';
import * as Yup from 'yup';
import { useProfile } from '@src/app/pages/TalentPage/TalentHooks/TalentDetail.hooks';
var ShareFormSchema = Yup.object().shape({
    divisionPubId: Yup.string().required('Field belum diisi'),
    teamPubId: Yup.string().required('Field belum diisi'),
});
var ProfileShareForm = function (_a) {
    var datas = _a.datas, handleClose = _a.handleClose, dataTalent = _a.dataTalent;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState({
        page: 1,
        pageSize: 100,
        keyword: '',
        filterBy: '[]',
        initialFilterBy: '[]',
    }), filterPageSize = _c[0], setFilterPageSize = _c[1];
    var shareProfile = useProfile(datas.pubId, false).shareProfile;
    var _d = useTeams(filterPageSize), team = _d.team, isLoadingTeam = _d.isLoading, errorTeam = _d.error;
    var _e = useDivisions(), divisions = _e.divisions, isLoadingDivisions = _e.isLoading, errorDivisions = _e.error;
    var optionTeam = team &&
        team.data &&
        team.data.length > 0 &&
        team.data.map(function (team) { return ({
            name: team.name,
            value: team.pubId,
        }); });
    var optionDivisions = divisions &&
        divisions.length > 0 &&
        divisions.map(function (division) { return ({
            name: "".concat(division.name, " - ").concat(division.socialMedia.name),
            value: division.pubId,
        }); });
    var shareValues = {
        divisionPubId: '',
        teamPubId: '',
    };
    var shareFormik = useFormik({
        initialValues: shareValues,
        enableReinitialize: true,
        validationSchema: ShareFormSchema,
        onSubmit: function (values, _a) {
            var setStatus = _a.setStatus, setSubmitting = _a.setSubmitting;
            return __awaiter(void 0, void 0, void 0, function () {
                var e_1, error;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            setLoading(true);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, shareProfile(__assign({ id: datas.pubId }, values))];
                        case 2:
                            _b.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _b.sent();
                            error = e_1.response.data;
                            setStatus(error.message);
                            setSubmitting(false);
                            setLoading(false);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
    });
    return (_jsx("form", __assign({ className: 'form w-100', onSubmit: shareFormik.handleSubmit, noValidate: true, id: 'jobtype-create-form' }, { children: _jsxs("div", { children: [_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: 'mb-3' }, { children: [_jsx("div", { children: _jsx(Typography, __assign({ variant: 'body1' }, { children: "Nama" })) }), _jsx("div", { children: _jsx(Typography, __assign({ variant: 'h6' }, { children: dataTalent.name })) })] })), _jsxs("div", __assign({ className: 'mb-3' }, { children: [_jsx("div", { children: _jsx(Typography, __assign({ variant: 'body1' }, { children: "Contact Person" })) }), _jsxs("div", { children: [_jsx(Typography, __assign({ variant: 'h6' }, { children: dataTalent.cpName })), _jsx(Typography, __assign({ variant: 'subtitle1' }, { children: dataTalent.cpPhoneNumber })), _jsx(Typography, __assign({ variant: 'subtitle1' }, { children: dataTalent.note ? dataTalent.note : '-' }))] })] })), _jsxs("div", __assign({ className: 'mb-3' }, { children: [_jsx("div", { children: _jsx(Typography, __assign({ variant: 'body1' }, { children: "Sosial media" })) }), _jsx("div", { children: _jsx(Typography, __assign({ variant: 'h6' }, { children: _jsx("div", __assign({ className: 'mt-2' }, { children: _jsx("a", __assign({ className: 'goto', href: datas.profileLink, target: '_blank', rel: 'noopener noreferrer' }, { children: datas.socialMedia.name })) })) })) })] }))] }), _jsx(Divider, {}), _jsxs(_Fragment, { children: [optionDivisions && (_jsx(SelectFormik, { name: "divisionPubId", label: 'Tipe', formik: shareFormik, optionList: optionDivisions, isRequired: true })), optionTeam && (_jsx(SelectFormik, { name: "teamPubId", label: 'Team', formik: shareFormik, optionList: optionTeam, isRequired: true }))] }), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs("div", __assign({ style: { textAlign: 'right' } }, { children: [_jsx("button", __assign({ type: 'button', className: 'btn btn-secondary btn-active-light-primary btn-sm', onClick: function () { return handleClose(false); }, style: { marginRight: '1rem' }, disabled: shareFormik.isSubmitting }, { children: "Batal" })), _jsxs("button", __assign({ type: 'submit', className: 'btn btn-primary btn-active-light-primary mr-2 btn-sm', disabled: shareFormik.isSubmitting }, { children: [!loading && _jsx("span", __assign({ className: 'indicator-label' }, { children: "Simpan" })), loading && (_jsxs("span", __assign({ className: 'indicator-progress', style: { display: 'block' } }, { children: ["Mohon tunggu...", _jsx("span", { className: 'spinner-border spinner-border-sm align-middle ms-2' })] })))] }))] })) }))] }) })));
};
export default ProfileShareForm;
